/*-- Routing --*/
import { Route, Switch, Redirect } from 'react-router-dom';
import { lazy, Suspense } from 'react';

/* Redux */
import { useSelector } from 'react-redux';

/*-- Layout --*/
import RecommendationsHeader from 'components/RecommendationsHeader';

/*-- Pages --*/
import LoadingRecommendations from 'components/LoadingRecommendations';
import UIDashboard from 'components/UIDashboard';
import UILaws from 'components/UILaws';
import UIWorkSearchActivity from 'components/UIWorkSearchActivity';
import FileClaim from 'components/FileClaim';
import Jobs from 'components/Jobs';
import Careers from 'components/Careers';
import Training from 'components/Training';
import Profile from 'components/Profile';
import ExperienceWallet from 'components/ExperienceWallet';
import Ratings from 'components/Ratings';

import JobSearchActivity from 'components/JobSearchActivity';
import ContinuedClaim from 'components/ContinuedClaim';
import UpdateMailingAddress from 'components/UpdateMailingAddress';
import UpdatePaymentMethod from 'components/UpdatePaymentMethod';
import ResumeBuilder from 'components/resume-builder';
const JSTMain = lazy(() => import('components/JSTcomponents/JSTMain'));

/*-- UI Components --*/
import NewUserTutorial from 'components/NewUserTutorial';
import NewUserTutorialMobile from 'components/NewUserTutorialMobile';
import { useMediaQuery } from '@mui/material';
import { UI_COMPONENTS_UNDER_MAINTENANCE } from '../../../constants/featureFlags';
import ReseaAppointmentScheduler from 'components/ReseaAppointmentScheduler';

const AuthenticatedPagesSwitch = () => {
  const hamburgerVisible = useMediaQuery('(max-width:959px)');
  const { loadingRecommendations, user_settings, urlPrefix, newUser } = useSelector((state) => state.app);
  const worksearch_status = useSelector((state) => state.worksearch.status);
  const UIEnabled =
    !UI_COMPONENTS_UNDER_MAINTENANCE &&
    user_settings.add_job_search_activity_hero_button &&
    process.env.REACT_APP_AR_UI === 'true';

  return loadingRecommendations ? (
    <LoadingRecommendations />
  ) : (
    <>
      {newUser && !hamburgerVisible && <NewUserTutorial claimant={!worksearch_status.ssn_required} />}
      {newUser && hamburgerVisible && <NewUserTutorialMobile claimant={!worksearch_status.ssn_required} />}
      <RecommendationsHeader />
      <Switch>
        {UIEnabled && (
          <Route path={[`/ui-dashboard`, `/:lang/ui-dashboard`]}>
            <UIDashboard />
          </Route>
        )}
        {UIEnabled && (
          <Route path={[`/ui-law-changes`, `/:lang/ui-law-changes`]}>
            <UILaws />
          </Route>
        )}
        {UIEnabled && (
          <Route path={[`/ui-work-search-activity`, `/:lang/ui-work-search-activity`]}>
            <UIWorkSearchActivity />
          </Route>
        )}
        {UIEnabled && (
          <Route path={[`/file-a-claim`, `/:lang/file-a-claim`]}>
            <FileClaim />
          </Route>
        )}

        {UIEnabled && (
          <Route path={[`/continued-claim`, `/:lang/continued-claim`]}>
            <ContinuedClaim />
          </Route>
        )}
        {UIEnabled && (
          <Route path={[`/mailing`, `/:lang/mailing`]}>
            <UpdateMailingAddress />
          </Route>
        )}
        {UIEnabled && (
          <Route path={[`/payment`, `/:lang/payment`]}>
            <UpdatePaymentMethod />
          </Route>
        )}
        {(window.location.origin === 'https://jobseeker.ar.dev.recengine.org' ||
          window.location.origin === 'https://jobseeker.ar.uat1.recengine.org' ||
          window.location.origin === 'http://localhost:3000') && (
          <Route path={[`/scheduling`]}>
            <ReseaAppointmentScheduler open={true} onComplete={() => {}} />
          </Route>
        )}
        <Route path={[`/jobs`, `/:lang/jobs`]}>
          <Jobs />
        </Route>
        <Route path={[`/careers`, `/:lang/careers`]}>
          <Careers />
        </Route>
        <Route path={[`/training`, `/:lang/training`]}>
          <Training />
        </Route>
        <Route exact path={[`/experience`, `/:lang/experience`]}>
          <ExperienceWallet />
        </Route>
        <Route exact path={[`/resume`, `/:lang/resume`]}>
          <ResumeBuilder />
        </Route>
        <Route path={['/job-search-activity', '/:lang/job-search-activity']}>
          {user_settings.add_job_search_activity_hero_button && !UI_COMPONENTS_UNDER_MAINTENANCE ? (
            <JobSearchActivity />
          ) : (
            <Redirect to={`${urlPrefix}/jobs`} />
          )}
        </Route>
        <Route path={[`/saved-items`, `/:lang/saved-items`]}>
          <Ratings />
        </Route>
        <Route path={[`/hidden-items`, `/:lang/hidden-items`]}>
          <Ratings />
        </Route>
        <Route path={[`/my-profile`, `/:lang/my-profile`]}>
          <Profile />
        </Route>
        <Route path={[`/jst`, `/:lang/jst`]}>
          <Suspense
            fallback={<div style={{ display: 'flex', justifyContent: 'center', padding: '64px 0' }}>Loading...</div>}
          >
            <JSTMain />
          </Suspense>
        </Route>
        <Route>
          <Redirect to={`${urlPrefix}/jobs`} />
        </Route>
      </Switch>
    </>
  );
};

export default AuthenticatedPagesSwitch;
